<template>
  <div class="unlimited-intro d-flex flex-column align-items-center">
    <h3 class="title text-center color-plum mb-0">
      Welcome!
    </h3>
    <h3 class="title text-center color-plum mb-0">
      Enjoy Unlimited Swaps
    </h3>
    <h3 class="title text-center color-plum mb-0">
      This Month
    </h3>
    <img
      :src="imgUrl"
      alt="Unlimited Intro"
      class="intro-image w-100 my-md">
    <p class="description text-center mb-lg">
      Try more styles, find your perfect fit, and swap as often as you want—free for your first month.
    </p>
    <div class="steps-container d-flex flex-column gap-sm">
      <div
        v-for="(step, index) in steps"
        :key="`step-${index}`"
        class="d-flex gap-xs align-items-start">
        <div class="step-bullet flex-shrink-0"/>
        <p class="mb-0">
          {{ step.text }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
const imgUrl = 'https://d2ezpplblfgpjx.cloudfront.net/onboarding/UnlimitedIntro.png'

const steps = [
  { text: 'Swap as soon as your first Case arrives' },
  { text: 'Swap one item or all of them (keep what you love)' },
  { text: 'Keep the first case until the new one arrives' }
]
</script>

<style lang="scss" scoped>
.unlimited-intro {
  width: 100%;
  @include media-tablet-or-smaller() {
    margin-top: 30%;
  }

  .title {
    margin-bottom: 0;
  }

  .description {
    margin-bottom: $spacing-lg;
  }

  .intro-image {
    aspect-ratio: 325 / 127;
    object-fit: contain;
    max-width: 325px;
  }

  .step-bullet {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: $orchid;
    margin-top: $spacing-xxs;
  }

  .steps-container {
    width: 100%;
    padding: 0 $spacing-xl;
  }
}
</style>

